let translateAPROF = {
	newsletterTitle: 'Hírlevél',
	newsletterSubtitle: 'Heti válogatás a legérdekesebb OTP ingatlanpontos hírek közül, illetve kiemelet ajánlatokról.'
};

export default translateAPROF;
